export default "__VITE_ASSET__BBXAlisH__"